import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';

const Step2 = ({ formData, updateFormData }) => {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFile = (file) => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    const maxSize = 10 * 1024 * 1024; // 10MB
    
    if (!allowedTypes.includes(file.type)) {
      alert(`Το αρχείο δεν είναι υποστηριζόμενου τύπου. Επιτρέπονται μόνο JPG, PNG και PDF.`);
      return;
    }
    
    if (file.size > maxSize) {
      alert(`Το αρχείο είναι πολύ μεγάλο. Μέγιστο μέγεθος: 10MB.`);
      return;
    }

    updateFormData({ identityDocument: file });
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const isPatient = formData.requesterType === 'patient';

  return (
    <div>
      <h3>Βήμα 2: Απαιτούμενα Δικαιολογητικά</h3>
      
      {isPatient ? (
        <>
          <p className="mb-20">
            Ως ασθενής, παρακαλώ επιλέξτε τρόπο επιβεβαίωσης της ταυτότητάς σας:
          </p>

          <div className="form-group">
            <label>
              Τρόπος επιβεβαίωσης: <span className="required">*</span>
            </label>
            <div className="radio-container" style={{ marginTop: '10px' }}>
              <label className="radio-option" style={{ 
                display: 'flex', 
                alignItems: 'flex-start', 
                marginBottom: '4px',
                padding: '10px 0 10px 0',
                border: `2px solid ${formData.identityMethod === 'upload' ? '#3498db' : '#e0e0e0'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                maxWidth: '600px',
              }}>
                <input
                  type="radio"
                  name="identityMethod"
                  value="upload"
                  checked={formData.identityMethod === 'upload'}
                  onChange={(e) => updateFormData({ identityMethod: e.target.value })}
                  style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
                />
                <div>
                  <strong>Επισύναψη Υπεύθυνης Δήλωσης από ΚΕΠ</strong>
                  <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                    Μεταφόρτωση αρχείου (PDF/JPG)
                  </div>
                </div>
              </label>
              
              <label className="radio-option" style={{ 
                display: 'flex',
                alignItems: 'flex-start',
                padding: '10px 0 10px 0',
                border: `2px solid ${formData.identityMethod === 'govgr' ? '#3498db' : '#e0e0e0'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                maxWidth: '600px',
              }}>
                <input
                  type="radio"
                  name="identityMethod"
                  value="govgr"
                  checked={formData.identityMethod === 'govgr'}
                  onChange={(e) => updateFormData({ identityMethod: e.target.value })}
                  style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
                />
                <div>
                  <strong>Έκδοση Υπεύθυνης Δήλωσης μέσω Gov.gr</strong>
                  <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                    Κατεβάστε το PDF από το Gov.gr και επισυνάψτε το παρακάτω.
                  </div>
                </div>
              </label>
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="mb-20">
            Ως εκπρόσωπος, παρακαλώ επιλέξτε τρόπο υποβολής της απαιτούμενης εξουσιοδότησης:
          </p>

          <div className="form-group">
            <label>
              Τρόπος υποβολής εξουσιοδότησης: <span className="required">*</span>
            </label>
            <div className="radio-container" style={{ marginTop: '10px' }}>
              <label className="radio-option" style={{ 
                display: 'flex', 
                alignItems: 'flex-start', 
                marginBottom: '4px',
                padding: '10px 0 10px 0',
                border: `2px solid ${formData.identityMethod === 'upload' ? '#3498db' : '#e0e0e0'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                maxWidth: '600px',
              }}>
                <input
                  type="radio"
                  name="identityMethod"
                  value="upload"
                  checked={formData.identityMethod === 'upload'}
                  onChange={(e) => updateFormData({ identityMethod: e.target.value })}
                  style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
                />
                <div>
                  <strong>Επισύναψη Εξουσιοδότησης μέσω ΚΕΠ</strong>
                  <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                    Μεταφόρτωση αρχείου (PDF/JPG)
                  </div>
                </div>
              </label>
              
              <label className="radio-option" style={{ 
                display: 'flex',
                alignItems: 'flex-start',
                padding: '10px 0 10px 0',
                border: `2px solid ${formData.identityMethod === 'govgr' ? '#3498db' : '#e0e0e0'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                maxWidth: '600px',
              }}>
                <input
                  type="radio"
                  name="identityMethod"
                  value="govgr"
                  checked={formData.identityMethod === 'govgr'}
                  onChange={(e) => updateFormData({ identityMethod: e.target.value })}
                  style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
                />
                <div>
                  <strong>Έκδοση Εξουσιοδότησης μέσω Gov.gr</strong>
                  <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                    Κατεβάστε το PDF από το Gov.gr και επισυνάψτε το παραπάνω
                  </div>
                </div>
              </label>
            </div>
          </div>
        </>
      )}

      {/* File Upload */}
      <div className="form-group">
        <label>
          Επισύναψη αρχείου {isPatient 
            ? (formData.identityMethod === 'govgr' ? 'ΥΔ από Gov.gr' : 'ΥΔ από ΚΕΠ')
            : (formData.identityMethod === 'govgr' ? 'Εξουσιοδότησης από Gov.gr' : 'Εξουσιοδότησης από ΚΕΠ')
          }: <span className="required">*</span>
        </label>
          <div
            className={`file-upload-area ${dragActive ? 'dragover' : ''}`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <Upload className="file-upload-icon" size={48} />
            <div className="file-upload-text">
              Κάντε κλικ ή σύρετε το αρχείο εδώ
            </div>
            <div className="file-upload-hint">
              Επιτρέπονται: JPG, PNG, PDF (μέγιστο 10MB)
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={handleFileInput}
              style={{ display: 'none' }}
            />
          </div>
        {formData.identityDocument && (
          <div style={{ marginTop: '10px', color: '#27ae60' }}>
            ✓ Αρχείο επιλέχθηκε: {formData.identityDocument.name}
          </div>
        )}
      </div>

      {formData.identityMethod === 'govgr' && (
        <div className="alert alert-info">
          <h4 style={{ marginTop: 0 }}>Οδηγίες για Gov.gr:</h4>
          <p style={{ marginBottom: '10px' }}>
            {isPatient 
              ? 'Συμπληρώστε στο πεδίο κειμένου της ΥΔ:'
              : 'Συμπληρώστε στο πεδίο κειμένου της Εξουσιοδότησης:'
            }
          </p>
          <div style={{ 
            background: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '4px',
            fontStyle: 'italic',
            marginBottom: '10px'
          }}>
            {isPatient 
              ? '"Συγκατατίθεμαι για την παραλαβή των αιτούμενων ιατρικών εγγράφων/εξετάσεων στην ηλεκτρονική μου διεύθυνση: [Email σας]"'
              : '"Εξουσιοδοτώ τον/την [ΟΝΟΜΑ ΕΚΠΡΟΣΩΠΟΥ] για την παραλαβή των αιτούμενων ιατρικών εγγράφων/εξετάσεων στην ηλεκτρονική διεύθυνση: [Email]"'
            }
          </div>
          <p style={{ fontSize: '14px', marginBottom: '10px' }}>
            Κατεβάστε το αρχείο PDF από το Gov.gr και επισυνάψτε το παραπάνω.
          </p>
          <p style={{ fontSize: '14px', margin: 0 }}>
            <a href={isPatient 
              ? "https://www.gov.gr/ipiresies/polites-kai-kathemerinoteta/psephiaka-eggrapha-gov-gr/ekdose-upeuthunes-deloses"
              : "https://www.gov.gr/ipiresies/polites-kai-kathemerinoteta/psephiaka-eggrapha-gov-gr/ekdose-exousiodotises"
            } 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#3498db' }}>
              → Μεταβείτε στο Gov.gr για {isPatient ? 'έκδοση ΥΔ' : 'έκδοση Εξουσιοδότησης'}
            </a>
          </p>
        </div>
      )}

      <div className="alert alert-info">
        <strong>📌 Σημαντικό:</strong> Σύμφωνα με την ισχύουσα νομοθεσία (ΚΙΔ), απαιτείται η επιβεβαίωση της ταυτότητας 
        για πρόσβαση σε ιατρικά δεδομένα. Τα στοιχεία σας θα χρησιμοποιηθούν μόνο για τη διεκπεραίωση του αιτήματός σας.
      </div>
    </div>
  );
};

export default Step2;
